import { INIT_ROOT, SAVED_BUILD_COUNT } from '../actionTypes';

export default function urls(state, action) {
  switch (action.type) {
    case INIT_ROOT:
      return action.payload.savedBuildCount;
    case SAVED_BUILD_COUNT:
      return action.payload;
    default:
      return state || 0;
  }
}
